import { render, staticRenderFns } from "./shopAccountManage.vue?vue&type=template&id=a436fd8a&scoped=true"
import script from "./shopAccountManage.vue?vue&type=script&lang=js"
export * from "./shopAccountManage.vue?vue&type=script&lang=js"
import style0 from "./shopAccountManage.vue?vue&type=style&index=0&id=a436fd8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a436fd8a",
  null
  
)

export default component.exports